import _ from "lodash";
import React, { useRef } from "react";
import LegalbirdIoConfirm from "../../Modal/LegalbirdIoConfirm";
import formElementAlertStyle from "./formElementAlertStyle";
import { translate } from "../../../services/Translations/translatorService";
import { Box } from "@mui/material";

type FormElementAlertProps = {
  isShowAlert: boolean;
  setIsShowAlert: Function;
  alert: Record<string, any>;
  initialValue: string;
  currentValue: string;
  handleChange: Function;
  onConfirm: Function;
  label: string;
  path: string;
  translationPath?: string;
};

export default function FormElementAlert({
  isShowAlert,
  setIsShowAlert,
  alert,
  initialValue,
  currentValue,
  handleChange,
  onConfirm,
  label,
  path,
  translationPath = path,
}: FormElementAlertProps) {
  const isAlertConfirmed = useRef(false);

  const getAlertContent = () => {
    if (currentValue === initialValue) {
      return null;
    }
    const action = _.isEmpty(initialValue) ? "onInitial" : "onChange";
    if (!alert[action]) {
      return null;
    }
    return (
      <Box component="p" sx={formElementAlertStyle.content}>
        Sie möchten den Wert im Feld "{label}" {action === "onInitial" ? "erstmalig eintragen" : "ändern"}
        {_.isString(currentValue) && (
          <>
            <br />"{translate(`${translationPath}.values.${initialValue}`, initialValue || "Leer")}"
            {' => "' + translate(`${translationPath}.values.${currentValue}`, currentValue)}"
          </>
        )}
        <br />
        <br />
        {alert[action]}
      </Box>
    );
  };

  if (!isShowAlert || !getAlertContent()) {
    return null;
  }

  const onCloseAlert = () => {
    if (!isAlertConfirmed.current) {
      handleChange({
        target: {
          name: path,
          value: initialValue,
        },
      });
    }
    setIsShowAlert(false);
  };

  const onConfirmAlert = () => {
    isAlertConfirmed.current = true;
    onConfirm();
  };

  return (
    <LegalbirdIoConfirm
      headline="Achtung"
      confirmText="Übernehmen"
      content={getAlertContent()}
      handleConfirm={onConfirmAlert}
      handleClose={onCloseAlert}
      open={true}
    />
  );
}
